<template>
  <div class="body-bg-white">
    <SPreloader />
    <SLandingTopBar />
    <SSubHeader :pageName="'Item details'" :backButton="true" />
    <div class="header-spacer"></div>
    <md-content class="page-content">
      <md-content class="md-elevation-1 mb-4 center-content">
        <section class="item-section">
          <div class="shop-product-detail">
            <div class="container">
              <div class="row">
                <div class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="item-trade-type" :class="[getBackgroundColor]">
                    <div class="text-content-trade-type">
                      <span class="poster-name mr-1">{{ posterName }}</span>
                      {{ wantText }}
                      <span class="ml-1 highlight-word">{{
                        getTradeType
                      }}</span>
                    </div>
                  </div>
                  <div class="thumbs-wrap">
                    <div
                      class="shop-product-detail-thumb mt-4"
                      :class="[
                        { 'item-unavailable': !isItemAvailable },
                        getTradeBorder,
                      ]"
                    >
                      <img
                        :src="getItemImagePath(itemProfile)"
                        alt="product"
                        class="main-img w-100 h-100 fit-contain"
                        style="background: white"
                        @click="openFullImage()"
                      />
                      <LoadingSpinner
                        position="absolute"
                        v-if="pageLoading === true"
                      />
                    </div>
                    <md-tooltip md-direction="bottom"
                      >Open full image</md-tooltip
                    >
                  </div>
                </div>
                <div class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="item-category-content">
                    <span class="item-category-title">
                      {{ itemCategoryProfile }}
                    </span>
                  </div>
                  <div class="shop-product-detail-content">
                    <div class="main-content-wrap">
                      <div class="block-title">
                        <h2
                          class="item-details-title bold fn"
                          data-cy="itemDetailsTitle"
                        >
                          {{ itemProfile.title }}
                        </h2>
                        <div class="h6 time-stamp">
                          <span class="time-ago"
                            >Posted
                            <span class="highlight-word">{{
                              itemProfile.createdAt | relativeDate
                            }}</span>
                            by
                            <router-link
                              class="profile-poster-link"
                              :class="[getLinkColor]"
                              :to="`/s-app/profile-page/${user.id}`"
                              >@{{ getPosterText }}</router-link
                            ></span
                          >
                        </div>
                      </div>
                      <div>
                        <SButtonMaterial
                          class="send-msg-item-btn"
                          buttonType="button"
                          :color="getTradeColor"
                          textColor="white"
                          materialClass="dense"
                          iconWithoutText="favorite"
                          iconColor="white"
                          @button="openLoginRegisterModal()"
                          data-cy="headerWishlistButton"
                        />
                      </div>
                    </div>

                    <hr class="hr-item" />
                    <div class="item-detail-content">
                      <h5 class="detail-sub-content">
                        Condition:
                        <span >
                          {{ getItemCondition(itemProfile) }}
                        </span>
                      </h5>
                      <div class="item-price">
                        <h5 class="detail-sub-content price-content">
                          Price:
                          <span v-if="isItemFree" class="ml-1">Free</span>
                          <span v-if="itemProfile.cash > 0" class="ml-1 mr-1"
                            >${{ getItemCash }}</span
                          >
                          <span
                            class="or-option mr-1"
                            v-if="paymentPointsAndCash"
                            >or</span
                          >
                          <div
                            class="points-option ml-1"
                            v-if="itemProfile.points > 0"
                          >
                            <img
                              class="mr-1"
                              src="/img/Polygon_7.svg"
                              alt="Swampum"
                              width="20"
                              height="20"
                            />
                            {{ getItemPoints.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                          </div>
                        </h5>
                      </div>
                    </div>
                    <p
                      class="text-break item-description title bold mt-5 h5"
                      data-cy="itemDetailsDescription"
                      v-linkified
                    >
                      {{ itemProfile.description }}
                    </p>
                  </div>
                  <span class="inline-items">
                  </span>
                  <div
                    class="user-item-actions"
                    v-if="!isItemFromUser && isItemAvailable"
                  >
                    <div class="mr-2">
                      <SButtonMaterial
                        class="trade-item-btn"
                        buttonType="button"
                        textColor="white"
                        iconColor="white"
                        iconLeftText="swap_horiz"
                        materialClass="dense"
                        :color="getTradeColor"
                        :class="[
                          { 'offer-item-class': getTradeText === 'offer' },
                        ]"
                        :text="getTradeText"
                        @button="openLoginRegisterModal()"
                        :data-cy="`itemTradeBtn-${itemProfile.title}`"
                      />
                    </div>
                    <div>
                      <SButtonMaterial
                        class="send-msg-item-btn"
                        :md-ripple="false"
                        buttonType="button"
                        textColor="white"
                        :iconColor="getTradeColor"
                        iconWithoutText="chat"
                        materialClass="dense"
                        @button="openLoginRegisterModal()"
                        :data-cy="`newItemChatButton-${itemProfile.title}`"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </md-content>
    </md-content>
    <Footer />
    <FullSizeImage
      ref="fullSizeImage"
      :images="[getItemImagePath(itemProfile)]"
    />
    <Modal
      id="login-redirect-modal"
      title="Authentication required"
      ref="modal"
      buttonName="Log in"
      buttonRegisterName="Register"
      @button="confirmRedirect()"
      @register="registerRedirect()"
      :materialButton="true"
      data-cy="confirmLoginRedirectButton"
    >
      <h5 class="login-text">Please log in or register to continue</h5>
    </Modal>
  </div>
</template>
<script>
import ItemHelper from "@/mixins/ItemHelper";
import itemType from "@/enum/item-type";
import linkify from "vue-linkify";
import requestSituation from "@/enum/request-situation";
import itemStatus from "@/enum/item-status";
import { mapGetters } from "vuex";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import Vue from "vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import store from "@/vuex/store";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import FullSizeImage from "@/material-components/molecules/FullSizeImage.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import Modal from "@/components/atoms/Modal.vue";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import Footer from "@/templates/Footer";


Vue.directive("linkified", linkify);

export default {
  name: "SItemDetailFromLandingPage",
  mixins: [ItemHelper, UserHelperVue, ChatHelperVue, PointsHelperVue],
  components: {
    SPreloader,
    SSubHeader,
    SButtonMaterial,
    FullSizeImage,
    LoadingSpinner,
    Modal,
    SLandingTopBar,
    Footer,

  },
  data() {
    return {
      iType: itemType,
      responseRequest: null,
      fetching: false,
      isOpen: false,
      reqSituation: requestSituation,
      checkTerms: false,
      state: "WAITING_CHECK",
      posterName: "",
      pageLoading: true,
      prevRoute: null,
      redirectTo: null,
      canRedirect: false,
    };
  },
  methods: {
    openFullImage() {
      this.$refs.fullSizeImage.openDialog();
    },
    openLoginRegisterModal() {
      this.$router.push(`/s-app/item-details/${this.itemProfile.id}`);
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal("hide");
    },
    registerRedirect() {
      this.closeModal("login-redirect-modal");
      this.canRedirect = true;
      this.$router.push(`/signup`);
    },
    async confirmRedirect() {
      this.closeModal("login-redirect-modal");
      this.canRedirect = true;
      await this.$router
        .push(this.redirectTo)
        .then(() => {
          this.canRedirect = false;
        })
        .catch(() => {
          console.log("user not logged");
        });
    },
    getPosterName() {
      if (this.user) {
        this.posterName = this.isItemFromUser
          ? "You"
          : this.getUserName(this.user);
      }
    },
    async setupItemPage() {
      await this.fetchItemProfile(this.$route.params.id);
      await this.fetchUserProfile(this.itemProfile.posterId);
      this.getPosterName();
    },
  },
  computed: {
    ...mapGetters({
      isUserAuthenticated: "isUserAuthenticated",
    }),
    itemCategoryProfile() {
      if (
        this.itemProfile !== undefined &&
        this.itemProfile.category !== undefined
      )
        return this.getItemCategory(this.itemProfile);
      return "";
    },
    isItemFromUser() {
      const userId = this.loggedUser && this.loggedUser.id;
      return this.itemProfile.posterId === userId;
    },
    isItemAvailable() {
      return itemStatus.IDLE === this.itemProfile.status
    },
    getPosterText() {
      return this.isItemFromUser ? "You" : this.user.username;
    },
    getTradeColor() {
      return itemType.GIVE === this.itemProfile.type ||
        itemType.LEND === this.itemProfile.type
        ? "tertiary"
        : "offer";
    },
    getLinkColor() {
      let type = this.itemProfile.type;
      return type === itemType.GIVE || type === itemType.LEND
        ? "link-tertiary"
        : "link-offer";
    },
    isItemFree() {
      return this.itemProfile.cash === 0 && this.itemProfile.points === 0;
    },
    getItemCash() {
      if (this.itemProfile.cash > 0) return `${this.itemProfile.cash}`;
      return "";
    },
    getItemPoints() {
      if (this.itemProfile.points > 0) return `${this.itemProfile.points}`;
      return "";
    },
    paymentPointsAndCash() {
      return this.itemProfile.cash > 0 && this.itemProfile.points > 0;
    },
    getTradeBorder() {
      let type = this.itemProfile.type;
      if (!this.isItemAvailable) return "border-image-unavailable";
      return type === itemType.GIVE || type === itemType.LEND
        ? "border-image-tertiary"
        : "border-image-offer";
    },
    getBackgroundColor() {
      let type = this.itemProfile.type;
      if (!this.isItemAvailable) return "background-item-unavailable";
      return type === itemType.GIVE || type === itemType.LEND
        ? "trade-type-tertiary"
        : "trade-type-offer";
    },
    wantText() {
      return this.isItemFromUser ? "want to" : "wants to";
    },
    getTradeType() {
      if (this.itemProfile.type === itemType.GIVE) {
        return "GIVE";
      } else if (this.itemProfile.type === itemType.RECEIVE) {
        return "RECEIVE";
      } else if (this.itemProfile.type === itemType.LEND) {
        return "LEND";
      } else {
        return "BORROW";
      }
    },
    getTradeText() {
      return itemType.GIVE === this.itemProfile.type ||
        itemType.LEND === this.itemProfile.type
        ? "Request"
        : "Offer";
    },
  },
  watch: {
    $route(to, from) {
      if (to.params !== from.params) this.setupItemPage();
    },
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchItemProfile", to.params.id);
    const itemValidation = store.getters["getItemProfile"];
    if (!itemValidation.error) {
      next(vm => { vm.prevRoute = from});
    } else {
      next("/");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isUserAuthenticated ||
      this.canRedirect ||
      to.path === "/" ||
      to.name === "loginRedirect" ||
      to.name === "SItemDetailFromLandingPage"
    ) {
      next();
    } else {
      if (
        to.path !== "/login" &&
        to.name !== "SSearchResultFromLandingPage" &&
        to.path !== "/signup" &&
        to.path !== "/landing-help" &&
        to.path !== "/contact-us" &&
        to.name !== "SItemDetailFromLandingPage"
      ) {
        this.redirectTo = to.fullPath;
        $("#login-redirect-modal").modal("show");
      } else {
        next();
      }
    }
  },
  beforeRouteUpdate(to) {
    this.$router.push({
      path: `/redirect?type=item-detail&item=${to.params.id}`,
    });
  },
  created() {
    this.setupItemPage();
    document.addEventListener("click", (event) => {
      if (
        !$(event.target).closest(".modal-content").length &&
        $("#accept").is(":visible")
      ) {
        this.closeModal();
      }
    });
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ trigger: "hover" });
    setTimeout(() => {
      this.pageLoading = false;
    }, 1000);
  },
};
</script>
<style scoped>
.item-unavailable {
  filter: grayscale(100%);
}
.fn {
  word-break: break-word;
}
</style>

<style lang="scss">
.time-stamp {
  color: #888da8;
  font-weight: 400;
  margin-bottom: 0 !important;
}
.item-details {
  display: inline-flex;
}
.item-category {
  border: 2px solid #ccc;
}
</style>
<style lang="scss" scoped>
.shop-product-detail-thumb {
  height: 290px;
}
.hr-item {
  margin-top: -10px !important;
}
</style>

<style lang="scss" scoped>
.page-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $light !important;
  letter-spacing: 1.25px;
}
.center-content {
  max-width: 1008px;
  width: 90%;
  min-height: 450px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 3.5rem;
  padding: 0 10px 10px;
}
.item-category-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
  padding-bottom: 1rem;
}
.item-details-title {
  font-weight: normal;
  font-size: 34px;
  line-height: 36px;
  color: rgba(0, 0, 0, 0.87);
}
.highlight-word {
  font-weight: bold;
}
.or-option {
  font-weight: normal !important;
}
.profile-poster-link {
  font-weight: 500;
  text-decoration: none !important;
}
.link-tertiary {
  color: $tertiary !important;
}
.link-offer {
  color: $offer !important;
}
.detail-sub-content {
  font-style: normal !important;
  font-weight: normal;
  span {
    font-weight: bold;
  }
}
.price-content {
  display: inline-flex;
  align-items: center;
}
.item-price span,
.points-option {
  font-weight: bold;
}
.item-detail-content {
  letter-spacing: 1.25px;
}
.item-price {
  display: inline-flex;
}
.points-option {
  display: flex;
}
.border-image-unavailable {
  margin-top: 0 !important;
  border: 3px solid $dark;
  box-sizing: border-box;
}
.border-image-tertiary {
  margin-top: 0 !important;
  border: 3px solid $tertiary;
  box-sizing: border-box;
}
.border-image-offer {
  margin-top: 0 !important;
  border: 3px solid $offer;
  box-sizing: border-box;
}
.item-trade-type {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 1.25px;
  span {
    font-size: 14px;
  }
}
.trade-type-tertiary {
  background-color: $tertiary;
}
.trade-type-offer {
  background-color: $offer;
}
.background-item-unavailable {
  background-color: $dark;
  filter: grayscale(100%);
}
.item-description {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 0.6) !important;
  margin-top: 0.5rem !important;
  margin-bottom: 2rem !important;
}
.text-content-trade-type {
  padding: 0.6rem;
}
.user-item-actions {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}
.trade-item-btn {
  border-radius: 5px !important;
  width: 110px;
  height: 40px;
}
.offer-item-class .button-content i {
  margin-right: 0.5rem;
}
.offer-item-class .button-content span {
  margin-right: 1rem;
}
.send-msg-item-btn {
  min-width: 35px !important;
}
.item-section {
  padding: 30px 5px 0px 5px;
}
.main-img {
  cursor: pointer;
}
.login-text{
  color: rgba(0, 0, 0, 0.6) !important
}
</style>
